// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__pErYi","HeaderUser":"Header_HeaderUser__oGEST"};